import { render } from "./SelfAssessmentV2Results.vue?vue&type=template&id=272ddbae"
import script from "./SelfAssessmentV2Results.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2Results.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2Results.vue?vue&type=style&index=0&id=272ddbae&lang=sass"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__